<template>
    <b-form-checkbox
        :button="button"
        :checked="checked"
        :disabled="disabled"
        :indeterminate="indeterminate"
        :inline="inline"
        :plain="plain"
        :required="required"
        :size="size"
        :state="state"
        :unchecked-value="uncheckedValue"
        :value="value"
        @change="$emit('change', $event)"
        @input="$emit('input', $event)"
        :class="['form-input-checkbox', {'placeholder-label': label === false }]"
    >
        <slot />

        <template v-if="tooltipText">
            <rkm-tooltip
                :target="uniqueId('info')"
                :placement="tooltipPosition"
            >
                {{ tooltipText }}
            </rkm-tooltip>

            <rkm-icon
                :id="uniqueId('info')"
                class="ml-1 mt-1"
                icon="info-circle"
            />
        </template>
    </b-form-checkbox>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'

export default {
    components: { BFormCheckbox },
    computed: {
        size() {
            return this.small ? 'sm' : (this.large ? 'lg' : (''))
        },
        tooltipPosition() {

            if (this.tooltipTop) {

                return 'top'
            }
            else if (this.tooltipRight) {

                return 'right'
            }
            else if (this.tooltipBottom) {

                return 'bottom'
            }
            else if (this.tooltipLeft) {

                return 'left'
            }

            return ''
        },
        id() {
            // TODO: Centralizar e a tratar melhor a string, removendo caracteres especiais, acentos, etc.
            const id = (this.label || this.name || 'unknown')
                .toLowerCase()
                .replace(/[()\\/\-<>]/gi, '')
                .replace(/[\s]/gi, '-')

            return this.uniqueId(id)
        },
    },
    created() {
        if (this.validator) {
            this.$validator = this.validator
        }
    },
    inject: {
        validator: { default: null, from: 'validator' }
    },
    model: { prop: 'checked', event: 'input' },
    props: {
        button: { type: Boolean },
        checked: { type: [Array, Boolean, String, Number, Object] },
        disabled: { type: Boolean },
        indeterminate: { type: Boolean },
        inline: { type: Boolean },
        label: { type: [String, Boolean], default: '' },
        large: { type: Boolean },
        plain: { type: Boolean },
        required: { type: Boolean },
        small: { type: Boolean },
        state: { type: Boolean, default: null },
        tooltipBottom: { type: Boolean },
        tooltipLeft: { type: Boolean },
        tooltipRight: { type: Boolean },
        tooltipText: { type: String },
        tooltipTop: { type: Boolean },
        uncheckedValue: { type: [Array, Boolean, String, Number, Object], default: false },
        value: { type: [Array, Boolean, String, Number, Object], default: true },
    }
}
</script>